// extracted by mini-css-extract-plugin
export var icon = "_4o-1";
export var subtext = "_4o-0";